export const WalletIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        d="M14,32a1,1,0,0,1,0,2H2.5a.5.5,0,0,0,0,1H14a2,2,0,0,1,2,2v7a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V34a2,2,0,0,1,2-2Zm-1,9.5a1,1,0,1,0-1-1A1,1,0,0,0,13,41.5Z"
        transform="translate(2 -29)"
      />
    </svg>
  );
};
